export default {
  user: window.$cookies?.get('user') || {},
  status: '',
  token: '',
  googleApi: window.$cookies?.get('api') || '',
  autoRefreshToken: null,
  exp: null,
  opusToken: {},
  opusPayload: {},
}
